// @ts-ignore
import {type Oidc} from "@webowski/nuxt-openid-connect/dist/runtime/plugin";

export const useProfile = (): Oidc => {
  const config = useRuntimeConfig()
  const oidc = useOidc()

  return {
    get user(): any {
      return oidc.user
    },
    get isLoading(): any {
      return oidc.isLoading
    },
    get getState(): any {
      return oidc.getState
    },
    get isLoggedIn(): boolean {
      return oidc.isLoggedIn
    },
    setLoading: (loading: boolean): void => {
      oidc.setLoading(loading)
    },
    setUser: (user: any): void => {
      oidc.setUser(user)
    },
    fetchUser: (): Promise<void> => {
      return oidc.fetchUser()
    },
    login: (redirect?: string): void => {
      oidc.login(redirect)
    },
    logout: (): void => {
      if (oidc.isLoggedIn) {
        // remove uuid cookie when logout
        const userUuid = useCookie(config.public.uuidCookieName)
        userUuid.value = null
        oidc.logout()
      }
    },
  }
}